import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

export function TimeInputFormField({ name }: { name: 'beginn' | 'ende' }) {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <form.AppField name={name}>
      {(field) => (
        <field.TimeInput
          label={
            name === 'ende'
              ? t('domain.termine.sheet.fields.bis')
              : t('domain.termine.sheet.fields.von')
          }
          className={cn(
            'w-full md:w-20',
            name === 'ende' &&
              field.state.meta.errors.length > 0 &&
              'border-primary-red-400',
          )}
        />
      )}
    </form.AppField>
  );
}
